
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import nsff263cd253870fcabf01031c73bc5f3ben from './en.yaml'
            i18n.addResourceBundle('en', 'ff263cd253870fcabf01031c73bc5f3b', flattenObject(nsff263cd253870fcabf01031c73bc5f3ben), true, true);
        
        export default 'ff263cd253870fcabf01031c73bc5f3b';
    